/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "Reality.Reality.Api";

/**
 * <strong>path=/api/v2/wise/in_service_region</strong>
 * アクセス元のIPアドレスを元に、ユーザーがWise関連の機能が許可されている地域にいるかどうかを判定する。
 * 判定に用いた地域の情報も一緒に返す。
 */
export interface WiseInServiceRegionResponse {
  inServiceRegion: boolean;
  GeoIPRegion: string;
}

function createBaseWiseInServiceRegionResponse(): WiseInServiceRegionResponse {
  return { inServiceRegion: false, GeoIPRegion: "" };
}

export const WiseInServiceRegionResponse = {
  encode(message: WiseInServiceRegionResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.inServiceRegion === true) {
      writer.uint32(8).bool(message.inServiceRegion);
    }
    if (message.GeoIPRegion !== "") {
      writer.uint32(18).string(message.GeoIPRegion);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WiseInServiceRegionResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWiseInServiceRegionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.inServiceRegion = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.GeoIPRegion = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WiseInServiceRegionResponse {
    return {
      inServiceRegion: isSet(object.inServiceRegion) ? globalThis.Boolean(object.inServiceRegion) : false,
      GeoIPRegion: isSet(object.GeoIPRegion) ? globalThis.String(object.GeoIPRegion) : "",
    };
  },

  toJSON(message: WiseInServiceRegionResponse): unknown {
    const obj: any = {};
    if (message.inServiceRegion === true) {
      obj.inServiceRegion = message.inServiceRegion;
    }
    if (message.GeoIPRegion !== "") {
      obj.GeoIPRegion = message.GeoIPRegion;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WiseInServiceRegionResponse>, I>>(base?: I): WiseInServiceRegionResponse {
    return WiseInServiceRegionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WiseInServiceRegionResponse>, I>>(object: I): WiseInServiceRegionResponse {
    const message = createBaseWiseInServiceRegionResponse();
    message.inServiceRegion = object.inServiceRegion ?? false;
    message.GeoIPRegion = object.GeoIPRegion ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
